import { useMutation, useQueryClient } from "@tanstack/react-query";
import { completeOnboarding } from "@/adapters/api";

export function useCompleteOnboarding() {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: completeOnboarding,
		onSuccess: () => queryClient.invalidateQueries({ queryKey: ["me"] }),
	});
}
